/** A connected voice call takes the agent's attention off email. */
export const isOnConnectedCall = (voiceContact: connect.Contact | null | undefined): boolean =>
  voiceContact?.getState().type === connect.ContactStateType.CONNECTED;

/**
 * The email contact the agent is actually looking at: the selected one, unless they are on a
 * connected call. Shared by everything that reacts to "viewing an email" (focus periods, the
 * email view timer) so they cannot disagree about when that stops.
 */
export const getViewedEmail = (
  selectedEmail: string | null,
  voiceContact: connect.Contact | null | undefined
): string | null => (isOnConnectedCall(voiceContact) ? null : selectedEmail);
